import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-textarea',
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.scss'],
    standalone: false
})
export class TextAreaComponent {
    @Input() placeholder!: string;
    @Input() subTitle!: string;
    @Input() value!: string;
    @Input() maxlength!: number;
    @Input() customClass: string
 
    @Output() onValueChange = new EventEmitter<string>();

    public textAreaFocus = false;

    onTextAreaFocus() {
        this.textAreaFocus = true;
    }

    onTextAreaBlur() {
        this.textAreaFocus = false;
    }

    onTextAreaChange() {
        this.onValueChange.emit(this.value);
    }

    onTextAreaKeyPress(e: KeyboardEvent) {
        e.stopPropagation();
        if(e.key === 'Enter') {
            e.preventDefault();
        }
    }
}